import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {
  ICategory,
  ICategoryImages,
  ICodeExists,
  INameExists,
  ISaveDeleteResponse,
  ICategoryImageExists
} from '../Shared/interface';
import {AppInsightsService} from './app-insights.service';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private baseURL = this.appService.config.apiBaseUrl;

  private options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

  constructor(private http: HttpClient,
              private appService: AppService) {
  }

  GetCategory(): Observable<ICategory[]> {
    return this.http.get<ICategory[]>(
      `${this.baseURL}/Category/GetCategories`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const category = res.body as ICategory[];
          return category;
        }),
        catchError(this.handleError)
      );
  }

  GetCategoryForOp(): Observable<ICategory[]> {
    return this.http.get<ICategory[]>(
      `${this.baseURL}/Category/GetCategoriesForOp`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const category = res.body as ICategory[];
          return category;
        }),
        catchError(this.handleError)
      );
  }

  GetcategoryDetails(id: number): Observable<ICategory> {
    return this.http.get<ICategory>(
      `${this.baseURL}/Category/GetcategoryDetails?categoryId=${id}`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const categoryDetail = res.body as ICategory;
          return categoryDetail;
        }),
        catchError(this.handleError)
      );
  }

  GetIsCodeExist(code: string): Observable<ICodeExists> {
    return this.http.get<ICodeExists>(
      `${this.baseURL}/Category/CategoryCodeExists?categoryCode=${code}`,
      {observe: 'response'})
      .pipe(
        map(result => {
            let isExist: boolean;
            const codeExist = result.body as ICodeExists;
            if ((typeof codeExist === 'undefined') || (codeExist === null)) {
              isExist = false;
              return codeExist;
            } else {
              return codeExist;
            }
          }
        ),
        catchError(this.handleError)
      );
  }

  GetIsNameExist(Name: string): Observable<INameExists> {
    return this.http.get<INameExists>(
      `${this.baseURL}/Category/CategoryNameExists?categoryName=${Name}`,
      {observe: 'response'})
      .pipe(
        map(result => {
            let isExist: boolean;
            const NameExist = result.body as INameExists;
            if ((typeof NameExist === 'undefined') || (NameExist === null)) {
              isExist = false;
              return NameExist;
            } else {
              return NameExist;
            }
          }
        ),
        catchError(this.handleError)
      );
  }

  GetIsImageExist(imgId: string): Observable<ICategoryImageExists> {
    return this.http.get<ICategoryImageExists>(
      `${this.baseURL}/Category/CategoryAllImageExists?imageid=${imgId}`,
      {observe: 'response'})
      .pipe(
        map(result => {
            let isExist: boolean;
            const imageExist = result.body as ICategoryImageExists;
            if ((typeof imageExist === 'undefined') || (imageExist === null)) {
              isExist = false;
              return imageExist;
            } else {
              return imageExist;
            }
          }
        ),
        catchError(this.handleError)
      );
  }

  GetAllCategoryImages(): Observable<ICategoryImages[]> {
    return this.http.get<ICategoryImages[]>(
      `${this.baseURL}/Category/GetAllCategoryImages`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const category = res.body as ICategoryImages[];
          return category;
        }),
        catchError(this.handleError)
      );

  }

  saveCategoryDetails(categorySav: ICategory): Observable<ISaveDeleteResponse> {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    let url = '';
    if (categorySav.Id === 0) {
      url = `${this.baseURL}/Category/CreateCategory`;
    } else {
      url = `${this.baseURL}/Category/UpdateCategory`;
    }
    return this.http.post<ISaveDeleteResponse>(url, categorySav, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  DeleteCategory(categoryId: number) {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    return this.http.post<any>(`${this.baseURL}/Category/DeleteCategory?categoryId=${categoryId}`, options);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

  private handleHttpPostError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

}
